module.exports = __webpack_public_path__ + "static/img/35.c42e2e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/35.jpg
// module id = dKtZ
// module chunks = 1